import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import { map, Observable } from 'rxjs';

export interface RvoMeldingeenheidDetails {
  meNummer: string | null;
  adresOmsME: string | null;
  postcodeME: string | null;
  plaatsnaamME: string | null;
  datumEindeME: string | null;
  xCoordinaat: string | null;
  yCoordinaat: string | null;
  vdvLatitude: number | null;
  vdvLongitude: number | null;
  pandIdBAG: string | null;
  typeBedrijfsvestiging: string | null;
  relatienummerHouder: string | null;
  naamHouder: string | null;
  kvknummerHouder: string | null;
  datumIngangVerantwHouder: string | null;
  datumEindeVerantwHouder: string | null;
  datumInactiefHouder: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class RvoUbnInfoService extends BaseService<unknown> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/rvo';
  }

  public ubnInfo(ubn: string, animalSpecies?: string | number): Observable<RvoMeldingeenheidDetails[]> {
    return this.postChild<{ data: RvoMeldingeenheidDetails[] }>(
      {
        ubn,
        ...(animalSpecies != null ? { animal_species: animalSpecies } : {})
      },
      'ubn_info'
    ).pipe(map((response) => response.data ?? []));
  }
}
